import type { IntentResult } from '@shared/types/types.ts';
import { isSimilarIntent } from '@shared/types/types.ts';
import { toProductItem } from '@tilelist/domain/composition/RankedPositioning.ts';
import type { TileListItem } from '@tilelist/domain/composition/TileListitem.ts';

/**
 *
 *
 *
 *
 */
export function appendSimilarProducts(
    intents: IntentResult[],
    tileListItems: TileListItem[],
    startingOffset: number,
): TileListItem[] {
    const similarIntent = intents.find(isSimilarIntent);
    const similarProductsHeader = { type: 'SPH' as const };

    if (!similarIntent || similarIntent.products.length === 0) {
        return tileListItems;
    }

    const similarProductItems = similarIntent.products.map((product, index) =>
        toProductItem({
            product,
            interleavedIndex: index + startingOffset,
            startingOffset: 0,
            originPosition: index,
        }),
    );

    return [...tileListItems, similarProductsHeader, ...similarProductItems];
}
